import webRtcSupport from 'webrtcsupport';
import { Log } from './log';

export class VideoUtils {
	private static isPageAlwaysAllowed(): boolean {
		return (
			location.href.includes('unsupported/room') ||
			location.href.includes('/login/mfacompleted') ||
			location.href.includes('/help') ||
			location.href.includes('/terms') ||
			(location.href.includes('/room') &&
				!location.href.includes('returnUrl=/room')) ||
			location.href.includes('/login/employee')
		);
	}

	private static isIos(): boolean {
		return /iPhone|iPad/i.test(navigator.userAgent);
	}

	private static isAndroid(): boolean {
		return /android/i.test(navigator.userAgent);
	}

	private static isFirefox(): boolean {
		return /firefox/i.test(navigator.userAgent);
	}

	private static isChrome(): boolean {
		return (
			/google/i.test(navigator.vendor) && !/edg/i.test(navigator.userAgent)
		);
	}

	private static isSafari(): boolean {
		return (
			/Apple/i.test(navigator.vendor) && /safari/i.test(navigator.userAgent)
		);
	}

	private static isChromiumEdge(): boolean {
		return /google/i.test(navigator.vendor) && /edg/i.test(navigator.userAgent);
	}

	public static getBrowser(): Browser {
		if (this.isChrome()) {
			return Browser.Chrome;
		} else if (this.isFirefox()) {
			return Browser.Firefox;
		} else if (this.isChromiumEdge()) {
			return Browser.ChromiumEdge;
		} else {
			return Browser.Unknown;
		}
	}

	public static isWebRtcSupported(): boolean {
		return webRtcSupport.support;
	}

	public static isVideoSupported(): boolean {
		if (this.isIos()) {
			return false;
		}

		if (this.isChrome() || this.isChromiumEdge() || this.isSafari()) {
			return true;
		}

		return false;
	}

	private static isLongOffsetSupported() {
		try {
			new Date().toLocaleDateString(undefined, {
				timeZoneName: 'longOffset' as any,
			});
			return true;
		} catch {
			return false;
		}
	}

	public static redirectIfUnsupported(): boolean {
		if (this.isPageAlwaysAllowed()) {
			return;
		}

		if (this.isVideoSupported() && this.isLongOffsetSupported()) {
			return;
		}

		const debug = {
			userAgent: navigator.userAgent,
			vendor: navigator.vendor,
			browserVersion: webRtcSupport.browserVersion,
			support: webRtcSupport.support,
			supportRTCPeerConnection: webRtcSupport.supportRTCPeerConnection,
			supportVp8: webRtcSupport.supportVp8,
			supportGetUserMedia: webRtcSupport.supportGetUserMedia,
			supportDataChannel: webRtcSupport.supportDataChannel,
			supportWebAudio: webRtcSupport.supportWebAudio,
			supportMediaStream: webRtcSupport.supportMediaStream,
			supportScreenSharing: webRtcSupport.supportScreenSharing,
			prefix: webRtcSupport.prefix,
		};

		Log.warn('Unsupported browser', debug);

		let errorPage = '/unsupported/desktop';

		if (this.isAndroid()) {
			errorPage = '/unsupported/android';
		}

		if (this.isIos()) {
			errorPage = '/unsupported/ios';
		}

		// Use XMLHttpRequest to maximize browser compatibility
		const request = new XMLHttpRequest();
		request.onreadystatechange = (): void => {
			if (request.readyState == 4) {
				const html = request.responseText;
				document.getElementsByTagName('html')[0].innerHTML = html;
			}
		};
		request.open('GET', errorPage, true);
		request.send();
	}

	public static isMediaElementSinkSupported(): boolean {
		return typeof (new Audio() as any).sinkId !== 'undefined';
	}
}

export enum Browser {
	Chrome,
	ChromiumEdge,
	Firefox,
	Unknown,
}
